/* 保証機関審査結果 */
import React, { useState } from 'react';
import RowTemplate from '../atoms/RowTemplate';
import ShelfInShelf from '../molecules/ShelfInShelf';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  disabled: boolean;
  looks_inactive?: boolean;
  result: string;
}

const GuaranteeAgencyExaminationResult: React.FC<Props> = ({
  id,
  label,
  need,
  disabled,
  looks_inactive,
  result,
}) => {
  const [is_open, setIsOpen] = useState(false);

  return (
    <ShelfInShelf id={id} label={label} is_open={is_open} handleClick={() => setIsOpen(!is_open)}>
      <RowTemplate
        label="保証機関審査結果"
        need={need}
        disabled={disabled}
        looks_inactive={looks_inactive}
        show={true}
        content={<>{result}</>}
      />
    </ShelfInShelf>
  );
};

export default GuaranteeAgencyExaminationResult;
